import * as validator from 'validator';
function validateUUID(input) {
    if (!validator.isUUID(input)) {
        throw new Error("Format Validation Error: string is not a valid UUID");
    }
}
var validationHelper = { validateUUID: validateUUID };
export { validationHelper };
